import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import { AccountingCards } from '../components/accounting/AccountingCards';
import { IncomeExpenseChart } from '../components/accounting/IncomeExpenseChart';
import { ProfitGauge } from '../components/accounting/ProfitGauge';
import { ExpenseBreakdown } from '../components/accounting/ExpenseBreakdown';
import { RecentTransactions } from '../components/accounting/RecentTransactions';
import { PipelineStats } from '../components/accounting/PipelineStats';
import { IncomeBreakdown } from '../components/accounting/IncomeBreakdown';
import { VendorExpenseBreakdown } from '../components/accounting/VendorExpenseBreakdown';
import { UpcomingRenewals } from '../components/accounting/UpcomingRenewals';
import { MonthlyExpenseManager } from '../components/accounting/MonthlyExpenseManager';

export default function AccountingPage() {
  const { api } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadDashboard = () => {
    setLoading(true);
    api.get('/api/accounting/dashboard')
      .then(res => setData(res.data))
      .catch(() => toast.error('Failed to load accounting data'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadDashboard();
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-4 border-[#014DB7] border-t-transparent rounded-full animate-spin" /></div>;
  if (!data) return <div className="text-center py-12 text-gray-500">Unable to load data</div>;

  return (
    <div className="space-y-6" data-testid="accounting-page">
      <div>
        <h1 className="text-2xl font-bold text-[#0A1628]">Accounting</h1>
        <p className="text-gray-500">Financial overview across your entire system</p>
      </div>
      <MonthlyExpenseManager api={api} onChanged={loadDashboard} />
      <AccountingCards data={data} />
      <div className="grid grid-cols-3 gap-6">
        <div className="col-span-2"><IncomeExpenseChart breakdown={data.monthly_breakdown} /></div>
        <ProfitGauge profit={data.profit} income={data.income} expenses={data.expenses} />
      </div>
      <div className="grid grid-cols-2 gap-6">
        <IncomeBreakdown items={data.income_breakdown} />
        <VendorExpenseBreakdown items={data.expense_breakdown_items} />
      </div>
      <div className="grid grid-cols-3 gap-6">
        <ExpenseBreakdown expenses={data.expenses} />
        <RecentTransactions transactions={data.recent_transactions} />
        <UpcomingRenewals renewals={data.upcoming_renewals} />
      </div>
      <div className="grid grid-cols-2 gap-6">
        <PipelineStats pipeline={data.pipeline} invoices={data.invoices} />
      </div>
    </div>
  );
}
